import PropTypes from 'prop-types';

const CustomSnackbar = ({ message, variant }) => {
    return <div data-testid={`snackbar-${variant}`}>{message}</div>;
};

CustomSnackbar.propTypes = {
    message: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['success', 'error', 'info']).isRequired,
};

export default CustomSnackbar;
